require('./RASuitabilityTestAccordion.scss');

// @vendors
const classNames = require('classnames');
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

// @components
import { Accordion } from 'commonsComponents/accordion';
import { AccordionHeader } from 'commonsComponents/accordionHeader';
import { AccordionBody } from 'commonsComponents/accordionBody';

class RASuitabilityTestResult extends React.Component {
    buildDescriptionHeader() {
        const { headerRiskProfileDescription } = this.props;
        return !!headerRiskProfileDescription ? (
            <div className="ra-suitability-test-accordion__investor-description">
                {headerRiskProfileDescription}
            </div>
        ) : null;
    }

    render() {
        const {
            alwaysShowSeparator,
            bodyRiskProfileDescription,
            clientRiskProfile,
            lastResultInvestorLabel,
            productDescription,
            legalTextDescription,
            sustainabilityProfile,
        } = this.props;
        const descriptionHeader = this.buildDescriptionHeader();

        const styleHeader = classNames(
            'ra-suitability-test-accordion__icon-section',
            {
                'ra-suitability-test-accordion__icon-section--separator': alwaysShowSeparator,
            },
        );
        const styleBody = classNames(
            'ra-suitability-test-accordion__description',
            {
                'ra-suitability-test-accordion__description--separator': !alwaysShowSeparator,
            },
        );

        const profileDesc = bodyRiskProfileDescription
            ? bodyRiskProfileDescription
            : null;

        return (
            <Accordion customClassName="ra-suitability-test-accordion">
                <AccordionHeader
                    name="AccordionHeader"
                    isRightArrowPosition
                    iconStyle
                >
                    <div className={styleHeader}>
                        <div className="ra-suitability-test-accordion__icon-container">
                            <i className="ra-suitability-test-accordion__icon" />
                        </div>
                        <div className="ra-suitability-test-accordion__info">
                            <div className="ra-suitability-test-accordion__investor-label">
                                {lastResultInvestorLabel}
                            </div>
                            <div className="ra-suitability-test-accordion__investor-type">
                                {clientRiskProfile}
                            </div>
                            {legalTextDescription}
                            {descriptionHeader}
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className={styleBody}>
                        <p>{profileDesc}</p>
                        <p>
                            <HTMLSafeInjector message={productDescription} />
                        </p>
                        {sustainabilityProfile}
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }
}

RASuitabilityTestResult.propTypes = {
    alwaysShowSeparator: PropTypes.boolean,
    bodyRiskProfileDescription: PropTypes.string,
    clientRiskProfile: PropTypes.string.isRequired,
    headerRiskProfileDescription: PropTypes.object,
    lastResultInvestorLabel: PropTypes.string,
    legalTextDescription: PropTypes.object,
    productDescription: PropTypes.string,
    sustainabilityProfile: PropTypes.object,
};

RASuitabilityTestResult.defaultProps = {
    alwaysShowSeparator: false,
    sustainabilityProfile: null,
};

module.exports = RASuitabilityTestResult;
